import {getjson,postjson,deletejson,putjson, download} from './http'

// 公共
// 登录
export const login = p => postjson('/api/Web/Login', p)
// 退出
export const loginOut = p => postjson('/api/Web/LoginOut', p)
// 验证码
export const codeImage = p => postjson('/api/Web/CodeImage', p)
// 获取ip
export const getIP = p =>postjson('http://ip-api.com/json', p)
// 获取科技信息列表
export const getTechInfoPage = p => postjson('/api/TechInfo/TechInfoPageByPC', p)
// 获取知识库信息列表
export const getKnowledgePage = p => postjson('/api/Knowledge/KnowledgePageByPC', p) 
// 获取园区服务信息列表
export const getAreaServicePage = p => postjson('/api/AreaService/AreaServicePageByPC', p)
// 获取政务信息列表
export const getGovInfoPage = p => postjson('/api/GovInfo/GovInfoPageByPC', p)

// 获取科技信息详情
export const getTechInfo = p =>postjson('/api/TechInfo/TechInfoByPC', p)
// 获取知识库详情
export const getKnowledge = p => postjson('/api/Knowledge/KnowledgeByPC', p)
// 获取园区服务详情
export const getAreaService = p => postjson('/api/AreaService/AreaServiceByPC', p)
// 获取政务信息详情
export const getGovInfo = p => postjson('/api/GovInfo/GovInfoByPC', p)

// 获取企业信息详情
export const EnterpriseInfoByPC = p =>postjson('/api/EnterpriseInfo/EnterpriseInfoByPC', p)

// 获取招聘信息列表
export const RecruitmentListByPC = p => postjson('/api/EnterpriseInfo/RecruitmentListByPC', p)
// 获取招聘信息详情
export const RecruitmentByPC = p =>postjson('/api/EnterpriseInfo/RecruitmentByPC', p)

// 获取合作信息详情
export const BusinessCoByPC = p =>postjson('/api/EnterpriseInfo/BusinessCoByPC', p)

// 首页轮播
export const AdvertisingListByPC = p =>postjson('/api/Advertising/AdvertisingListByPC', p)

// 未读信息
export const MessagePage = p => postjson('/api/Web/MessagePage', p)
// 标为已读
export const SetMsgRead = p => postjson('/api/Web/SetMsgRead', p)

// 获取企业申报分页
export const EnterpriseStatisticsPageByPC = p => postjson('/api/EnterpriseStatistics/EnterpriseStatisticsPageByPC', p)
// 获取企业申报
export const EnterpriseStatisticsByPC = p => postjson('/api/EnterpriseStatistics/EnterpriseStatisticsByPC', p)
// 保存企业申报
export const SaveEnterpriseStatisticsByPC = p => postjson('/api/EnterpriseStatistics/SaveEnterpriseStatisticsByPC', p)
// 提交
export const SaveSubmitByPC = p => postjson('/api/EnterpriseStatistics/SaveSubmitByPC', p)
// 申请修改
export const EnterpriseStatisticsChangeByPC = p => postjson('/api/EnterpriseStatistics/EnterpriseStatisticsChangeByPC', p)
// 申请提交
export const EnterpriseStatisticsSubmitByPC = p => postjson('/api/EnterpriseStatistics/EnterpriseStatisticsSubmitByPC', p)

// 获取发布期间列表
export const GetDateSpanList = p => postjson('/api/EnterpriseStatisticsEntry/GetDateSpanList', p)
// 获取统计页字段列表
export const ESEFList = p => postjson('/api/EnterpriseStatisticsEntry/ESEFList', p)
// 获取统计页筛选列表
export const ESEFilterList = p => postjson('/api/EnterpriseStatisticsEntry/ESEFilterList', p)
// 获取统计报表分页
export const ESEPageByPC = p => postjson('/api/EnterpriseStatisticsEntry/ESEPageByPC', p)
// 导出数据统计
export const ESEListToExcelByPC = p => postjson('/api/EnterpriseStatisticsEntry/ESEListToExcelByPC', p)

// 获取招商引资分页
export const getInvestmentPage = p => postjson('/api/Investment/InvestmentPageByPC', p)
// 获取招商引资详情
export const getInvestment = p => postjson('/api/Investment/InvestmentByPC', p)
// 获取工改工分页
export const getIndustryToPage = p => postjson('/api/IndustryTo/IndustryToPageByPC', p)
// 获取工改工详情
export const getIndustryTo = p => postjson('/api/IndustryTo/IndustryToByPC', p)

export const getEnterpriseInfoListByArea = p => postjson('/api/EnterpriseInfo/EnterpriseInfoListByArea', p)


// WEBPACK FOOTER //
// ./src/api/api2.js